import { createSelector } from 'reselect'
import { forIn } from 'lodash'

const accountSelector = state => state.account.currentAccount

export const getCurrentAccountId = createSelector(accountSelector, (account) => {
    return account.id
})

export const getCurrentAccount = state => {
  if(!state.account.entities || !state.account.entities.accounts){
    return null
  }

  let accountData = state.account.entities.accounts[state.account.currentAccountId]

  if(accountData && accountData.folders){
    return accountData
  }else{
    return null
  }
}

export const getAccountProjectsUtil = (account, allProjects) => {
  const projects = []

  account && forIn(allProjects, project => {
    if(project.account_id == account.id){
      projects.push(project)
    }
  })

  return projects
}

export const getAccountProjects = createSelector(
	[
    state => getCurrentAccount(state),
    state => state.account.entities.projects
	],
	(account, allProjects) => {
    return getAccountProjectsUtil(account,allProjects)
  }
)


export const getLastSeenAccount = state => {
	let account = null;

	if(state.account.entities && state.account.entities.accounts && state.account.entities.users){
    const user = state.account.entities.users[state.auth.userId];

    if(user && user.last_open_account_id){
			account = state.account.entities.accounts[state.account.entities.users[state.auth.userId].last_open_account_id];
		}
	}

	return account;
}

export const isPremium = state => {
  const account = getCurrentAccount(state)

  return account && account.isPremium
}